export default __webpack_public_path__ + "static/media/1.2f5098e6.jpg";